module.exports = __webpack_public_path__ + "img/doc_2_preview.b490c59c.jpg";